import React from 'react';
import { Box, Grid } from '@mui/material';
import NewsUpdatesPanel from './NewsUpdatesPanel';

/** Right-rail news for dashboards that are not the teaching timetable. */
export default function DashboardWithNews({ children }) {
  return (
    <Grid container spacing={2} alignItems="flex-start">
      <Grid item xs={12} md={8} lg={9}>
        {children}
      </Grid>
      <Grid item xs={12} md={4} lg={3}>
        <Box sx={{ position: { md: 'sticky' }, top: { md: 16 } }}>
          <NewsUpdatesPanel compact />
        </Box>
      </Grid>
    </Grid>
  );
}
